// extracted by mini-css-extract-plugin
export default {"container":"styles_container__if50-","title":"styles_title__a68Fr","wrapper":"styles_wrapper__VCy+m"};